/**
 * StorageContext.js
 * 
 * Context provider for the storage manager service.
 * Makes storage operations available throughout the application.
 */
import React, { createContext } from 'react';

// Create the context
export const StorageContext = createContext(null);

/**
 * Storage context provider
 * @param {Object} props - Component props
 * @param {StorageManager} props.storage - Storage manager instance
 * @param {React.ReactNode} props.children - Child components
 */
export const StorageProvider = ({ storage, children }) => {
  return (
    <StorageContext.Provider value={{ storage }}>
      {children}
    </StorageContext.Provider>
  );
};
